import { render, staticRenderFns } from "./RecentOrdersRoute.vue?vue&type=template&id=7f501246&"
import script from "./RecentOrdersRoute.vue?vue&type=script&lang=ts&"
export * from "./RecentOrdersRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports